export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/squarespace.23d6b53.svg";